import { createContext, useContext } from 'react';
import type { ResolvedTheme, ThemePreference } from './themeStorage';

export interface ThemeContextValue {
  /** The user's choice. `system` follows the operating system. */
  theme: ThemePreference;
  /** The theme actually shown. */
  resolvedTheme: ResolvedTheme;
  setTheme: (theme: ThemePreference) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

/** Current theme preference and setter. Requires `ThemeProvider`. */
export const useTheme = (): ThemeContextValue => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used inside <ThemeProvider>');
  return context;
};
